// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gr","advertCardHeader__actions":"c-a_gs","advertCardHeader__bottomLabel":"c-a_gt"};